



































































import { Component, Prop, Model, Watch, Vue } from 'vue-property-decorator';
// import { State, Action, Getter } from 'vuex-class';
import { BotData } from '../store-types';
import { Param } from './IntentParameter.vue';

@Component<WordOptionsPopup>({
  // components: {VMenu, VCombobox, VList}
  mounted() {
    this.displayPopup = false;
    this.$nextTick(() => {
      this.displayPopup = true;
      // console.info('focus on menu...', this.$refs.editParameter);
      // // (this.$refs.editParameter.$el as HTMLElement).tabIndex = 0;
      // setTimeout(() => {
      //   // this.$refs.editParameter.$el.focus();
      //   this.$refs.menu.$el.focus();
      // }, 2000);
    });
  }
})
export default class WordOptionsPopup extends Vue {
  @Prop() public menu: {x?: number, y?: number, start?: number, end?: number, words?: string[] | null} = {};
  // @State('bot') public bot: BotData;

  public name: string | null = null;
  public entity: string | null = null;
  public value: string | null = null;

  private displayPopup = true;
  private mode: number = 0;
  private delayedClose = false;
  private valid = false;

  private nameRules = [
      (v: string) => !!v && !!v.trim() || 'Name is required'
  ];

  @Watch('menu')
  private onMenu() {
    console.info('menu changed');
    // this.delayedClose = false;
    // setTimeout(() => {
    //   this.delayedClose = true;
    // }, 2000);
  }

  // private get displayPopup() {
  //   return true; // !!this.menu.words;
  // }

  private get displayMenu() {
    return this.mode === 0 && (!this.param || !(this.param as Param).display);
  }

  private get param(): string | Param | undefined {
    if (this.menu.words) {
      const words = this.menu.words;
      if (this.menu.start === this.menu.end) {
        return words[this.menu.start!];
      }
      return words.slice(this.menu.start, this.menu.end! + 1).join(' ');
    }
  }

  private get entityValues() {
    if (this.entity) {
// TODO: what's going on here? what is this.entity? What is this.entities?
      const values = this.entities[this.entity as any];
      if (values) {
        return Object.keys(values);
      }
    }
  }

  private get suggestedEntity(): {entity?: string; value?: string} {
    const param = this.param;

    if (param) {
      if ((param as Param).entity) {
        return param as Param;
      }

      const entities = this.entities;

      for (const entity in entities) {
        if (entities.hasOwnProperty(entity)) {
// TODO: what's going on here?  Is Typescript right? (remove 'as any' below)
          for (const value in entities[entity] as any) {
            if (entities[entity].hasOwnProperty(value)) {
              const aliases = entities[entity][value as any];

              for (const alias of aliases) {
                if (alias === param) {
                  return {entity, value};
                }
              }
            }
          }
        }
      }
    }

    return {};
  }

  private get entities() {
    const bot: BotData = this.$store.state.bots[this.$route.params.botId];
    return bot && Object.keys(bot.entities!) || [];
    // return this.BotData && this.BotData.entities;
  }

  private editParameter() {

    // this.param = null;
    this.mode = 3;
    const self = this;
    setTimeout(function() {
      (self.$refs.menu as any).updateDimensions();
    }, 1000);

    // this.menu.x = 20;
  }

  private onUpdateName($event: string) {
    this.name = $event;
    // console.info('validating...');
    // (this.$refs.form as any).validate();
  }

  private onOk() {
    if ((this.$refs.form as any).validate()) {
      this.$emit('update:parameter', {
        name: this.name,
        entity: this.entity || this.suggestedEntity.entity,
        value: this.value || this.suggestedEntity.value,
        start: this.menu.start,
        end: this.menu.end
      } as UpdateParameterEvent);

      this.onClose();
    }
  }

  private emitAndClose(event: 'edit' | 'ignore' | 'delete:parameter') {
    this.$emit(event, this.menu);
    this.onClose();
  }

  private onValue(val: string) {
    console.info('onValue', val);
    if (val) {
      this.onClose();
    }
  }

  private onClose() {
    console.info('close WordOptionsPopup');
    this.displayPopup = false;
    this.menu.words = null;
    // Vue.set(this.menu, 'words', null);

    setTimeout(() => {
      this.mode = 0;
    }, 500);
  }
}

export interface UpdateParameterEvent {
  name: string;
  entity: string;
  value: string;
  start: number;
  end: number;
}
